<!--Wird von allen Brands in der Aktivierung Summary benutzt-->
<template>
  <div class="personalData personal-data" v-if="customer.lastName">
    <slot name="txtBefore"></slot>
    <b-row class="salution">
      <b-col md="" sm="12" class="label">
        <slot name="labelSalutation">Anrede</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{getSalutationString(customer.salutation)}}</b-col>
    </b-row>
    <b-row class="firstName">
      <b-col md="" sm="12" class="label">
        <slot name="labelFirstName">Vorname</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{customer.firstName}}</b-col>
    </b-row>
    <b-row class="lastName">
      <b-col md="" sm="12" class="label">
        <slot name="labelLastName">Nachname</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{customer.lastName}}</b-col>
    </b-row>
    <b-row class="streetNumber">
      <b-col md="" sm="12" class="label">
        <slot name="labelStreetNumber">Straße / Hausnr.</slot>
      </b-col>
      <b-col md="" sm="12" class="value">
        <span class="street">{{customer.address.street}}</span>&nbsp;<span class="houseNumber">{{customer.address.houseNumber}}</span>
      </b-col>
    </b-row>
    <b-row class="zipCity">
      <b-col md="" sm="12" class="label">
        <slot name="labelZipCity">PLZ / Ort</slot>
      </b-col>
      <b-col md="" sm="12" class="value">
        <span class="zip">{{customer.address.zip}}</span>&nbsp;<span class="city">{{customer.address.city}}</span>
      </b-col>
    </b-row>
    <b-row class="supplement" v-if="customer.address.supplement != null">
      <b-col md="" sm="12" class="label">
        <slot name="labelSupplement">Adresszusatz</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{customer.address.supplement}}</b-col>
    </b-row>
    <b-row class="phone" v-if="customer.alternativePhone != null && viewPhone">
      <b-col md="" sm="12" class="label">
        <slot name="labelPhone">Telefon</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{customer.alternativePhone}}</b-col>
    </b-row>
    <b-row class="birthDate" v-if="customer.birthDate != null">
      <b-col md="" sm="12" class="label">
        <slot name="labelBirthDate">Geburtsdatum</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{customer.birthDate}}</b-col>
    </b-row>
    <b-row class="email" v-if="customer.email != null">
      <b-col md="" sm="12" class="label">
        <slot name="labelEmail">E-Mail Addresse</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{customer.email}}</b-col>
    </b-row>
  </div>
</template>

<script>

import { BCol, BRow } from 'bootstrap-vue'

export default {
  name: 'ShowPersonalData',
  props: {
    customer: {
      type: Object
    },
    viewPhone: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'b-row': BRow,
    'b-col': BCol
  },
  methods: {
    getSalutationString (gender) {
      if (gender === 'MALE') {
        return 'Herr'
      }
      if (gender === 'FEMALE') {
        return 'Frau'
      }
      return gender
    }
  }
}
</script>
